import { createTheme } from '@mui/material';

export const theme = createTheme({
    typography: { fontFamily: '"Be Vietnam Pro", system-ui, -apple-system, Segoe UI, Roboto, Arial' },
});
